export default {"src":"/_next/static/image/public/images/flags/flag_7_russian_federation.68a7ffd3e8bf79185901d60df12911a0.svg","height":16,"width":24};